import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useI18n } from "@/i18n";
import { articles } from "@/data/articles";

const COPY = {
  it: { overline: "Risorse", title: "Guide alla mobilità business.", sub: "Approfondimenti per organizzare al meglio la mobilità aziendale.", all: "Tutte le risorse", read: "Leggi" },
  en: { overline: "Resources", title: "Business mobility guides.", sub: "Insights to organize your corporate mobility at its best.", all: "All resources", read: "Read" },
};

export function ResourcesTeaser() {
  const { lang } = useI18n();
  const c = COPY[lang];
  return (
    <section id="resources" className="bg-background py-24 md:py-32 border-t border-border">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
            <div>
              <p className="overline text-accent">{c.overline}</p>
              <h2 className="mt-4 font-serif text-4xl md:text-6xl tracking-tight leading-[1.02]">{c.title}</h2>
              <p className="mt-5 max-w-xl text-muted-foreground text-base md:text-lg">{c.sub}</p>
            </div>
            <Link to="/risorse" data-testid="resources-all-link" className="inline-flex items-center gap-2 text-accent font-medium whitespace-nowrap">
              {c.all} <ArrowRight size={16} />
            </Link>
          </div>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-3 gap-8">
          {articles.map((a, i) => (
            <Reveal key={a.slug} delay={i * 0.08}>
              <Link to={`/risorse/${a.slug}`} data-testid={`teaser-article-${a.slug}`}>
                <motion.article whileHover={{ y: -6 }} transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                  className="group h-full border border-border bg-card overflow-hidden flex flex-col">
                  <div className="h-48 overflow-hidden">
                    <img src={a.image} alt={a[lang].title} className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105" />
                  </div>
                  <div className="p-6 flex flex-col flex-1">
                    <h3 className="font-serif text-xl tracking-tight leading-tight">{a[lang].title}</h3>
                    <p className="mt-3 text-muted-foreground text-sm leading-relaxed flex-1">{a[lang].excerpt}</p>
                    <span className="mt-5 inline-flex items-center gap-2 text-accent text-sm font-medium">{c.read} <ArrowUpRight size={15} /></span>
                  </div>
                </motion.article>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
